var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { gql, useMutation } from "@apollo/client";
var LIKE_COMMUNITY_REQUEST_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation LikeCommunityRequestMutation($id: String!) {\n      likeCommunityRequest(communityRequestId: $id) {\n        id\n        likedBy {\n          id\n          name\n          photo {\n            url\n          }\n        }\n      }\n    }\n  "], ["\n    mutation LikeCommunityRequestMutation($id: String!) {\n      likeCommunityRequest(communityRequestId: $id) {\n        id\n        likedBy {\n          id\n          name\n          photo {\n            url\n          }\n        }\n      }\n    }\n  "])));
var UNLIKE_COMMUNITY_REQUEST_MUTATION = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation UnlikeCommunityRequestMutation($id: String!) {\n      unlikeCommunityRequest(communityRequestId: $id) {\n        id\n        likedBy {\n          id\n          name\n          photo {\n            url\n          }\n        }\n      }\n    }\n  "], ["\n    mutation UnlikeCommunityRequestMutation($id: String!) {\n      unlikeCommunityRequest(communityRequestId: $id) {\n        id\n        likedBy {\n          id\n          name\n          photo {\n            url\n          }\n        }\n      }\n    }\n  "])));
export var useCommunityRequestLikeMutations = function () {
  var _a = __read(useMutation(LIKE_COMMUNITY_REQUEST_MUTATION), 2),
    likeCommunityRequest = _a[0],
    likeError = _a[1].error;
  var _b = __read(useMutation(UNLIKE_COMMUNITY_REQUEST_MUTATION), 2),
    unlikeCommunityRequest = _b[0],
    unlikeError = _b[1].error;
  return {
    likeCommunityRequest: likeCommunityRequest,
    unlikeCommunityRequest: unlikeCommunityRequest,
    likeError: likeError,
    unlikeError: unlikeError
  };
};
var templateObject_1, templateObject_2;